import { selectors } from 'modules/common';
import { domain, State } from 'modules/data';
import { useSelector } from 'modules/react-redux';

export const useGetUserCompanyById = (companyId: domain.Company['id']) => {
    return useSelector((state: State) => selectors.company.findCompanyById(state, companyId));
};
